export enum PERMISSION {
  CREATE_USER = "Create user",
  EDIT_USER = "Edit user",
  VIEW_USERS = "View users",

  DELETE_USER = "Delete user",

  CREATE_STATION = "Create station",
  EDIT_STATION = "Edit station",
  VIEW_STATIONS = "View stations",
  DELETE_SATION = "Delete station",

  CREATE_SENSOR = "Create sensor",
  EDIT_SENSOR = "Edit sensor",
  VIEW_SENSORS = "View sensors",
  DELETE_SENSOR = "Delete sensor",

  CREATE_PATIENT = "Create patient",
  EDIT_PATIENT = "Edit patient",
  VIEW_PATIENTS = "View patients",
  DELETE_PATIENT = "Delete patient",
  VIEW_PATIENT_SENSOR_STATISTICS = "View patient's sensor statistics (graphs)",

  PATIENT_DASHBOARD = "Patient Dashboard",
  COMPLETE_PATIENT_ASSESSMENT_FORM = "Complete the patient's assessment form",

  VIEW_PATIENT_SELF_ASSESSMENTS = "View patient's self-assessments",

  CREATE_SENSOR_DATA_SESSION = "Create sensor data session",
  EDIT_SENSOR_DATA_SESSION = "Edit sensor data session",
  VIEW_SENSOR_DATA_SESSIONS = "View sensor data sessions",
  DELETE_SENSOR_DATA_SESSION = "Delete sensor data session",

  CREATE_SENSOR_DATA_FILE = "Create sensor data file",
  EDIT_SENSOR_DATA_FILE = "Edit sensor data file",
  VIEW_SENSOR_DATA_FILES = "View sensor data files",
  DELETE_SENSOR_DATA_FILE = "Delete sensor data file",

  VIEW_HOSPITAL_DASHBOARD = "View hospital dashboard",

  VIEW_HOSPITAL_ALERTS = "View hospital alerts",
  MANAGE_HOSPITALS_ALERTS = "Manage Hospital Notifications",

  VIEW_USER_ALERTS = "View user alerts",
  MANAGE_CUSTOM_ALERTS = "Manage Custom Patient Notifications",

  MANAGE_HOSPITALS_SETTINGS = "Manage hospital`s settings",
  SET_UP_STABLE_PERIOD = "Set Up Stable Period",

  GET_NOTIFIED_BY_SMS_EMAIL = "Get notified by SMS/Email",

  ALLOW_IMPORTANT_NOTIFICATIONS_AS_SMS = "Allow Patient Notifications as SMS",
  ALLOW_IMPORTANT_NOTIFICATIONS_AS_EMAIL = "Allow Patient Notifications as Email",
  VIEW_SDH_DETAILED_DATA_CHART = "View SDH Detailed Data chart",

  ALLOW_STABLE_PARAMETERS_NOTIFICATIONS_AS_SMS = "Allow Stable Parameters Notifications as SMS",
  ALLOW_STABLE_PARAMETERS_NOTIFICATIONS_AS_EMAIL = "Allow Stable Parameters Notifications as Email",

  ALLOW_MISSED_FORMS_PER_WEEK_NOTIFICATIONS_AS_SMS = "Allow Missed Forms Per Week Notifications As SMS",
  ALLOW_MISSED_FORMS_PER_WEEK_NOTIFICATIONS_AS_EMAIL = "Allow Missed Forms Per Week Notifications As Email",

  ALLOW_MISSED_FORMS_NOTIFICATIONS_AS_SMS = "Allow Missed Forms Notifications as SMS",
  ALLOW_MISSED_FORMS_NOTIFICATIONS_AS_EMAIL = "Allow Missed Forms Notifications as Email",

  GET_FORMS_REPORT = "Get forms report",
  GET_SESSIONS_REPORT = "Get sessions report",

  CREATE_SENSOR_DATA_RESTORING_REQUEST = "Create sensor data restoring request",
  VIEW_SENSOR_DATA_RESTORING_REQUESTS = "View sensor data restoring requests",
  DELETE_SENSOR_DATA_RESTORING_REQUESTS = "Delete sensor data restoring request",

  CHANGE_EPOCH_THRESHOLD_IN_THE_REPORT = "Change epoch threshold in the report",

  EXPORT_DETAILED_RR_HR_DATA_UNFILTERED = "Export Detailed RR and HR Data (Unfiltered)",
}
